import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const ContentAbovePaywallContainer = styled.div`
  position: relative;
`;

export const PayWalledContentContainer = styled.div<{ $isAccessibleForUser: boolean }>`
  ${({ $isAccessibleForUser }) =>
    !$isAccessibleForUser
      ? css`
          display: none;
        `
      : null}
`;
